import { animate, state, style, transition, trigger } from '@angular/animations';

export const loadingAnimation = trigger('loadingAnimation', [
  state('hidden', style({ opacity: 0.5, transform: 'scale(0.99)', filter: 'grayscale(100%)', 'z-index': '-1'})),
  state('active', style({ opacity: 1, transform: 'scale(1)', filter: 'grayscale(0%)', background: 'transparent'})),
  state('loading', style({ opacity: 0.5, transform: 'scale(0.99)', filter: 'grayscale(100%)'})),
  transition('active => hidden', animate('300ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
  transition('loading => active', animate('200ms 150ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
]);
